import { Classification } from "@/src/models/constants/classifications";
import { Workflow, WorkflowType } from "@/src/models/constants/group";
import { Section } from "@/src/models/section";

export const ENTS_REFERRAL_ASSIGNEE = "Hernandez,Virginia";

// eCW facility "ENT Specialists" (Code ENTSPECIAL, Clarendon Hills, IL) — confirmed live via the
// facilities directory. Not to be confused with facility Id 90, "TELEHEALTH ENT Specialists"
// (POS 2), a distinct telehealth-specific record in the same tenant.
export const ENTS_TEL_ENC_FACILITY_ID = "87";
export const ENTS_TEL_ENC_FACILITY_POS = "11";

// Every non-REFERRAL classification is forwarded here rather than processed — ENTS's build is
// referrals-only.
export const ENTS_NON_REFERRAL_FAX_NUMBER = "+18555381762";

// Non-REFERRAL classifications forwarded via fax. Broader than the parent ENTP group's extract
// list — includes doc types ENTS can receive that ENTP processes differently (PROGRESS_NOTE,
// MEDICAL_HISTORY, MEDICAL_RECORD_REQUEST, REFERRAL_STATUS_REQUEST, OTHER). Excludes
// REFERRAL (own workflow), BLANK, JUNK, COVER_PAGE (no value in forwarding).
export const ENTS_FAX_CLASSIFICATIONS: Classification[] = [
  Classification.DME_ORDER,
  Classification.IDENTIFICATION_CARD,
  Classification.IMAGING_RESULTS,
  Classification.INSURANCE_CARD,
  Classification.INTAKE,
  Classification.LAB_RESULTS,
  Classification.MEDICAL_HISTORY,
  Classification.MEDICAL_RECORD_REQUEST,
  Classification.OTHER,
  Classification.PHARMACY_RELATED,
  Classification.PRIOR_AUTHORIZATION,
  Classification.PROCEDURE_SLEEP,
  Classification.PROGRESS_NOTE,
  Classification.REFERRAL_STATUS_REQUEST,
  Classification.REFERER_INFORMATION,
  Classification.RESPONSE_TO_VH_REQUEST,
];

const ENTS_FAX_CLASSIFICATIONS_SET = new Set(ENTS_FAX_CLASSIFICATIONS);

export function getEntsClassificationToExtract(): Classification[] {
  return [...ENTS_FAX_CLASSIFICATIONS, Classification.REFERRAL];
}

// Fax-forwarding docs don't need a patient — skip patient resolution entirely so
// the section isn't blocked waiting on a lookup task or fails if no patient was extracted.
export function isEntsPatientlessDoc(section: Section): boolean {
  return ENTS_FAX_CLASSIFICATIONS_SET.has(section.uploadClassification || section.classification);
}

export function getEntsWorkflows(): Partial<Record<WorkflowType, Classification[]>> {
  return {
    [Workflow.REFERRAL]: [Classification.REFERRAL],
    [Workflow.DOC_MANAGEMENT]: ENTS_FAX_CLASSIFICATIONS,
  };
}
